import { i18n } from '@/i18n';
import { LOCALE_COOKIE_NAME } from '@/i18n/config';
import { setCookie } from '@/utils/cookie';
import type { LocaleValues, MessageKey } from '@/i18n/types';
import type VueI18n from 'vue-i18n';

/**
 * Перевод по ключу. Для <script setup>, сторов, утилит и констант —
 * в Options API можно использовать this.$t
 *
 * @param key - ключ словаря
 * @param values - значения для подстановки в {placeholder}
 */
export const t = (key: MessageKey, values?: VueI18n.Values): string =>
    i18n.t(key, values) as string;

/**
 * Перевод с плюрализацией: 'нет лидов | {count} лид | {count} лида | {count} лидов'
 *
 * @param key - ключ словаря
 * @param count - число, по которому выбирается форма
 * @param values - значения для подстановки в {placeholder}
 */
export const tc = (key: MessageKey, count: number, values?: VueI18n.Values): string =>
    i18n.tc(key, count, { count, ...values });

/**
 * Переключает язык приложения: запоминает его в куке и перезагружает страницу,
 * чтобы тексты, посчитанные при загрузке модулей (константы), пересчитались
 *
 * @param locale - код языка
 */
export const setLocale = (locale: LocaleValues): void => {
    setCookie(LOCALE_COOKIE_NAME, locale, {
        domain:   window.location.hostname,
        expires:  365,
        samesite: 'lax',
    });
    window.location.reload();
};
